import { render, staticRenderFns } from "./exhibition-info-catalogueAlter.vue?vue&type=template&id=0a0f993a&scoped=true&"
import script from "./exhibition-info-catalogueAlter.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-catalogueAlter.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-catalogueAlter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-info-catalogueAlter.vue?vue&type=style&index=1&id=0a0f993a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f993a",
  null
  
)

export default component.exports